import React from 'react';

const ListWidget = ({ title, data, onClick }) => {
  const handleItemClick = (item) => {
    if (onClick) {
      onClick({ type: 'listItem', title, data: item });
    }
  };

  const handleViewAll = () => {
    if (onClick) {
      onClick({ type: 'listViewAll', title, data });
    }
  };

  return (
    <div className="h-full bg-white p-5 rounded-lg shadow-sm hover:shadow-md transition-shadow flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        <button
          onClick={handleViewAll}
          className="text-secondary-600 hover:text-secondary-800 text-sm font-medium hover:underline"
        >
          View All
        </button>
      </div>
      <div className="flex-1 overflow-y-auto space-y-3">
        {data.map((item, index) => (
          <div
            key={item.id || index}
            onClick={() => handleItemClick(item)}
            className="flex items-center justify-between p-3 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors"
          >
            <div className="flex items-center gap-3">
              {item.avatar ? (
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
              ) : (
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-primary-700 font-medium text-sm">
                    {item.name?.charAt(0)?.toUpperCase() || '?'}
                  </span>
                </div>
              )}
              <div>
                <p className="font-medium text-gray-900">{item.name}</p>
                {item.subtitle && (
                  <p className="text-xs text-gray-500">{item.subtitle}</p>
                )}
              </div>
            </div>
            <div className="text-right">
              <p className="font-semibold text-gray-900">{item.value}</p>
              {item.subValue && (
                <p className="text-xs text-gray-500">{item.subValue}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListWidget;
